import {computed} from "vue";

const useSafekeepOrder = () => {
  const route = useRoute()

  const isOrderSafekeepMode = computed(() => {
    return route.path && (route.path as string).includes('/safekeep')
  })

  return {
    isOrderSafekeepMode
  }
}

export default useSafekeepOrder
